import { useState } from 'react'

import { Modal } from 'almanac-ui/Modal'
import { Button } from 'components/Button'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import useShareSheetV2 from 'hooks/useShareSheetV2'
import { ReactComponent as CloseArrow } from 'assets/icons/arrowLeft16.svg'
import { TakeOwnershipConfirmationProps } from './Types'
import Styles from './ShareSheet.module.scss'

export const TakeOwnershipConfirmation = ({ newOwnerId, file }: TakeOwnershipConfirmationProps) => {
  const { isMobile } = useResponsiveDesign()
  const fileType = file.type === 'article' ? 'document' : file.type
  const { transferOwnership, setShareSheet } = useShareSheetV2(file)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const goBack = () => {
    setShareSheet({ takeOwnership: false })
    setIsSubmitting(false)
  }

  const handleTransfer = () => {
    setIsSubmitting(true)
    transferOwnership({ id: newOwnerId, goBack })
  }

  return (
    <Modal.Root size={isMobile ? 'xs' : 'sm'}>
      <Modal.Top>
        <Button size="md" onPress={goBack} variant="tertiary" className={Styles.backButton}>
          <CloseArrow />
        </Button>
      </Modal.Top>
      <Modal.Header title={<div className={Styles.title}>Take Ownership</div>} />
      <Modal.Content>
        <div className={Styles.transferText}>
          The current owner might lose the ability to change this {fileType}’s share settings. You can transfer your
          ownership to other members again.
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button size="lg" variant="tertiary" onPress={goBack}>
            Cancel
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Button size="lg" onPress={handleTransfer} isDisabled={isSubmitting}>
            Take Ownership
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
